import { Component, ViewChild } from '@angular/core';

@Component({
  selector: 'app-public-notification',
  standalone: false,
  templateUrl: './public-notifications.component.html'
})
export class PublicNotificationsComponent {

  notification = {
    message: "Trademark Renewal Due",
    date: "November 9, 2025",
    header: "INNOVATE PRO - Trademark Registration",
    owner: "TechCorp Industries Ltd.",
    registeredWith: "United States Patent and Trademark Office",
    registeredYear: "2020",
    registrationNumber: "6234567",
    classOrType: "9, 42",
    status: "Feb 15, 2026",
    refId: "TM-US-6634234-2020"
  }

  constructor() {

  }

  summaryDetails() {
    return `${this.notification.header} | ${this.notification.owner} | ${this.notification.registeredWith} | ${this.notification.registrationNumber} | ${this.notification.classOrType} | ${this.notification.registeredYear} | ${this.notification.status}`
  }
}
